import React, { lazy, Suspense } from 'react';

import { Head as SEO, Team } from '@landing/components';
import Header from 'components/Header';
import { anchorLinksForHomePage } from 'define/anchorLinks';
import Intro from 'components/Intro';
import EventLocations from 'components/EventLocations';
import Interviews from 'components/Interviews';
import Services from 'components/Services';
import Projects from 'components/Projects';
import Offices from 'components/Offices';
import { offices } from 'define/offices';
import Gallery from 'components/Gallery';
import Footer from 'components/Footer';
import CookiesPolicy from 'components/CookiesPolicy';
import { useIsSsr } from 'utils/hooks';

import data from './data.json';

const ConsentModal = lazy(() =>
  import('components/Modals').then(({ ConsentModal }) => ({
    default: ConsentModal,
  })),
);

export default function Index() {
  const isSsr = useIsSsr();

  return (
    <>
      <Header anchorLinks={anchorLinksForHomePage} showButton={false} />
      <Intro {...data.intro} />
      <Team {...data.team} />
      <EventLocations {...data.eventLocations} />
      <Interviews {...data.interviews} />
      <Services {...data.services} />
      <Projects {...data.projects} />
      <Offices offices={offices} {...data.offices} />
      <Gallery {...data.gallery} />
      <Footer anchorLinks={anchorLinksForHomePage} />
      <CookiesPolicy />
      {!isSsr && (
        <Suspense fallback={null}>
          <ConsentModal />
        </Suspense>
      )}
    </>
  );
}

export const Head = () => <SEO {...data.head} />;
